module.exports = __webpack_public_path__ + "img/walk.092172b6.png";